/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AlertCheckbox/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function AlertCheckbox({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/AlertCheckbox",
  onChange,
  isSubmitting
  
}) {
let scheduleNoteAlertThisDayValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'alert_this_day',
})
let scheduleNoteAlertThisDayChangeData = fromData.useDataChange({ viewPath,
context: 'schedule_note',
path: 'alert_this_day',
})
let scheduleNoteAlertThisDayIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'schedule_note',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Alert when viewing this date?"
 data="schedule_note.alert_this_day"
 value={scheduleNoteAlertThisDayValueData}
 onChange={scheduleNoteAlertThisDayChangeData}
 disabled={scheduleNoteAlertThisDayIsSubmittingData}
/>
{children}
</React.Fragment>)
}